var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 13.4168C13.2261 13.4168 12.4843 13.1095 11.9373 12.5626C11.3903 12.0156 11.083 11.2737 11.083 10.5002C11.083 9.72661 11.3903 8.98475 11.9373 8.43777C12.4843 7.89079 13.2261 7.5835 13.9997 7.5835C14.7732 7.5835 15.5151 7.89079 16.0621 8.43777C16.6091 8.98475 16.9163 9.72661 16.9163 10.5002C16.9163 10.8832 16.8409 11.2625 16.6943 11.6163C16.5477 11.9702 16.3329 12.2917 16.0621 12.5626C15.7912 12.8334 15.4697 13.0482 15.1158 13.1948C14.762 13.3414 14.3827 13.4168 13.9997 13.4168ZM13.9997 2.3335C11.8337 2.3335 9.75652 3.19391 8.22497 4.72546C6.69342 6.257 5.83301 8.33423 5.83301 10.5002C5.83301 16.6252 13.9997 25.6668 13.9997 25.6668C13.9997 25.6668 22.1663 16.6252 22.1663 10.5002C22.1663 8.33423 21.3059 6.257 19.7744 4.72546C18.2428 3.19391 16.1656 2.3335 13.9997 2.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e7151eec2be9b9855c3aa6e97ede81b5.svg";
export { ForwardRef as ReactComponent };